// extracted by mini-css-extract-plugin
export default {"license":"IncodeCaptureLicense-module__license-QANb","illustration":"IncodeCaptureLicense-module__illustration-bf6a","moveHand":"IncodeCaptureLicense-module__moveHand-LG1s"};